"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectErrorComponentWithStatusCode = exports.errorComponentMap = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var rate_limit_1 = require("./rate-limit");
var default_error_1 = require("./default-error");
var errorComponentMap = function (errorProps) {
    return new Map([
        [429, (0, jsx_runtime_1.jsx)(rate_limit_1.RateLimit, __assign({}, errorProps), 0)],
        [503, (0, jsx_runtime_1.jsx)(rate_limit_1.RateLimit, __assign({}, errorProps), 1)],
        [504, (0, jsx_runtime_1.jsx)(rate_limit_1.RateLimit, __assign({}, errorProps), 2)],
    ]);
};
exports.errorComponentMap = errorComponentMap;
var SelectErrorComponentWithStatusCode = function (_a) {
    var status = _a.status, userComponentMap = _a.userComponentMap, DefaultErrorComponent = _a.DefaultErrorComponent, errorProps = _a.errorProps;
    return ((userComponentMap && userComponentMap.get(status)) ||
        (0, exports.errorComponentMap)(errorProps).get(status) ||
        DefaultErrorComponent || (0, jsx_runtime_1.jsx)(default_error_1.DefaultError, {}));
};
exports.SelectErrorComponentWithStatusCode = SelectErrorComponentWithStatusCode;
